import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';


const ProfitBar = ({ height, data, vendor }) => {
    const monthWiseData = {};
    data.forEach((item) => {
        if (item?.monthStr) {
            if (monthWiseData[`${item.monthStr}-${item.year}`]) {
                monthWiseData[`${item.monthStr}-${item.year}`].push(item)
            } else {
                monthWiseData[`${item.monthStr}-${item.year}`] = [item]
            }
        }
    })

    const reduceCallback = (acc, item) => {

        if (vendor === 'shopify') {
            const shippingEst = Number((item.grossRevenue * 25) / 100)
            const netProf = Number(item.grossRevenue) - Number(shippingEst) - Number(item.cost)
            return acc + netProf
        }

        return acc + Number(item.netProfit)
    };
    const allMonthsSelected = Object.keys(monthWiseData)
    const dataToPlot = []
    for (let month = 0; month < allMonthsSelected.length; month += 1) {
        const currentMonthDayData = monthWiseData?.[allMonthsSelected[month]] ?? [];

        const monthData = currentMonthDayData?.reduce(reduceCallback, 0)
        dataToPlot.push({
            title: allMonthsSelected[month],
            "Net Profit": monthData
        })
    }

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart
                width={500}
                height={300}
                data={dataToPlot}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                <XAxis dataKey="title" />
                <YAxis type="number" />
                <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(2), true)} />
                <Legend />
                <Bar dataKey={"Net Profit".toString()} fill="#82ca9d" />
            </BarChart>
        </ResponsiveContainer>
    )
}

ProfitBar.propTypes = {

    height: PropTypes.number.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    vendor: PropTypes.string.isRequired
};

export default React.memo(ProfitBar);